import React from 'react'
import { useTranslation } from 'react-i18next'
import { CustomerDetailsSection } from 'pages/Customers/ConfirmCustomer/CustomerDetails'
import { BUSINESS_CUSTOMER_LABEL_MAPPING } from '../helpers/form'
import { ConfirmBusinessCustomerData } from '../helpers/types'

export interface ConfirmBusinessProps {
  business: ConfirmBusinessCustomerData
}

export const ConfirmBusiness = ({ business }: ConfirmBusinessProps) => {
  const { t } = useTranslation()
  const { data, displayData } = business || {}

  return (
    <CustomerDetailsSection
      customerDetails={Object.keys(data)?.map(key => ({
        label: t(BUSINESS_CUSTOMER_LABEL_MAPPING?.[key] ?? `embeddedCustomers.businessForm.${key}`),
        value: displayData?.[key] ?? data?.[key],
      }))}
    />
  )
}
